import { authHeaders, requestJson } from './http';
import type { Story } from '../context/AppContext';

const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';

/**
 * One story record from the existing GET /stories/{story_id} endpoint. Used
 * when a surface needs a story's identity (title, artwork) and the catalog
 * held by AppContext has not loaded it, for example a direct entry to a
 * review. Callers treat a failure as "no artwork", never as a page error.
 */
export async function fetchStory(storyId: string, signal?: AbortSignal): Promise<Story> {
  return requestJson<Story>(`${API_BASE_URL}/stories/${encodeURIComponent(storyId)}`, {
    headers: authHeaders(),
    signal,
  });
}
